import postLink from "@utils/postLink";

export default () => ({
  open: null,

  deleteAddress(url, message) {
    if (confirm(message)) {
      postLink(url, {
        parameters: { _method: "delete" },
      });
    }
  },
});
